import colours from "./colours.json";

export const ralToHex = (ral) => {
  if (!ral || !colours[ral]) {
    return "#FFFFFF";
  } else {
    return colours[ral];
  }
};

export const computeHexNumber = (value) => {
  return Number(`0x${value}`);
};